import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { UserServices } from '../redux/Services';
const { Header, Content,Footer } = Layout;

const LayoutMain = () => {
    const [collapsed, setCollapsed] = useState(false);
    const dispatch = useDispatch();

    // Load the role's permissions; refresh when the tab regains focus so an
    // admin's role changes apply without logging out
    useEffect(() => {
        const load = () => dispatch(UserServices.fetchMyAccessApi());
        load();
        window.addEventListener('focus', load);
        return () => window.removeEventListener('focus', load);
    }, []);

    return (
        <>
            <Layout className='layout_css'>
                <Sidebar collapsed={collapsed} />
                <Layout className="site-layout">
                    <Header className="site-layout-background" style={{ padding: 0 }}>
                        <TopBar collapsed={collapsed} setCollapsed={setCollapsed} />
                    </Header>
                    <Content
                        className="site-layout-background"
                        style={{
                            margin: '6px',
                            padding: 10,
                            minHeight: 280,
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        }}
                    >
                        <Outlet />
                    </Content>
                    <Footer></Footer>
                </Layout>
            </Layout>
        </>
    )
}

export default LayoutMain